import React from 'react';
import { Box, IconButton, Typography, TextField, MenuItem } from '@mui/material';
import { ChevronLeft, ChevronRight } from '@mui/icons-material';

const CustomPagination = ({
  page,
  totalPages,
  rowsPerPage,
  onPageChange,
  onRowsPerPageChange,
  customRowsActive,
  customRowsInput,
  onCustomRowsInputChange,
  onCustomRowsInputBlur
}) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: { xs: 'center', sm: 'flex-end' }, flexWrap: 'wrap', mt: 2, gap: { xs: 1, sm: 2 } }}>
      <IconButton onClick={() => onPageChange(page - 1)} disabled={page === 0}>
        <ChevronLeft />
      </IconButton>
      <Typography variant="body2">
        Page {totalPages === 0 ? 0 : page + 1} of {totalPages}
      </Typography>
      <IconButton onClick={() => onPageChange(page + 1)} disabled={page >= totalPages - 1}>
        <ChevronRight />
      </IconButton>
      <Typography variant="body2" sx={{ ml: 2 }}>
        Rows per page:
      </Typography>
      {!customRowsActive ? (
        <TextField
          select
          size="small"
          value={[10, 20, 50, 100].includes(rowsPerPage) ? rowsPerPage : 'custom'}
          onChange={onRowsPerPageChange}
          sx={{ width: 100 }}
        >
          {[10, 20, 50, 100].map((option) => (
            <MenuItem key={option} value={option}>{option}</MenuItem>
          ))}
          <MenuItem value="custom">Custom</MenuItem>
        </TextField>
      ) : (
        <TextField
          size="small"
          value={customRowsInput}
          onChange={onCustomRowsInputChange}
          onBlur={onCustomRowsInputBlur}
          autoFocus
          sx={{ width: 100 }}
          inputProps={{ min: 1, style: { textAlign: 'center' } }}
          placeholder="Rows"
        />
      )}
    </Box>
  );
};

export default CustomPagination; 
